(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["activa-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.neuActivaLoaded) return;
  window.neuActivaLoaded = true;
  const roots = new Set();
  const route = (path) => (window.Shopify?.routes?.root || '/') + path;
  const words = () => JSON.parse(document.querySelector('[data-ac-i18n]')?.textContent || '{}');
  let busy = false;
  const state = (root) => ({ promo: Date.now() <= Date.parse(root.dataset.deadline) });
  const tick = (root) => {
    const s = state(root);
    root.querySelectorAll('[data-ac-promo]').forEach(n => n.hidden = !s.promo);
    root.querySelectorAll('[data-ac-regular]').forEach(n => n.hidden = s.promo);
    let total = Math.max(0, Math.floor((Date.parse(root.dataset.deadline) - Date.now()) / 1000)) || 0;
    const time = {days: Math.floor(total/86400), hours: Math.floor(total/3600)%24, minutes: Math.floor(total/60)%60, seconds:total%60};
    root.querySelectorAll('[data-ac-time]').forEach(n => n.textContent = String(time[n.dataset.acTime]).padStart(2,'0'));
    root.querySelectorAll('[data-ac-count-label]').forEach(n => n.textContent = s.promo ? words().deadline : words().expired);
  };
  const post = async (path, body) => {
    const response = await fetch(route(path), {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || words().error);
    return data;
  };
  const reset = () => {
    busy=false;
    roots.forEach(root=>{root.querySelector('[data-ac-overlay]')?.setAttribute('hidden','');root.querySelectorAll('[data-ac-buy][data-was-enabled]').forEach(n=>{n.disabled=false;delete n.dataset.wasEnabled;});tick(root);});
  };
  const init = (scope) => {
    scope.querySelectorAll('[data-ac-root]').forEach(root=>{
      if(roots.has(root))return;
      roots.add(root); tick(root);
      root.querySelectorAll('[data-ac-copy]').forEach(button=>button.addEventListener('click',async()=>{
        if(!state(root).promo)return;
        try {
          if(navigator.clipboard?.writeText) await navigator.clipboard.writeText(root.dataset.code);
          else {const input=document.createElement('textarea');input.value=root.dataset.code;input.style.cssText='position:fixed;opacity:0';document.body.append(input);input.select();const ok=document.execCommand('copy');input.remove();if(!ok)throw new Error();}
          button.textContent=words().copied;
        } catch {button.textContent=words().copy_error+' '+root.dataset.code;}
        setTimeout(()=>button.textContent=words().copy,3000);
      }));
      root.querySelectorAll('[data-ac-form]').forEach(form=>form.addEventListener('submit',async(event)=>{
        event.preventDefault();
        if(busy)return;
        busy=true;
        const error=form.closest('.ac-offer').querySelector('[data-ac-error]');error.textContent='';
        const overlay=root.querySelector('[data-ac-overlay]');
        root.querySelectorAll('[data-ac-buy]:not(:disabled)').forEach(n=>{n.dataset.wasEnabled='true';n.disabled=true;});
        if(overlay)overlay.hidden=false;
        const started=Date.now();
        let added=false;
        try {
          await post('cart/add.js',{items:[{id:new FormData(form).get('id'),quantity:1}]});added=true;
          const delay=matchMedia('(prefers-reduced-motion: reduce)').matches?0:Math.max(0,850-(Date.now()-started));
          await new Promise(resolve=>setTimeout(resolve,delay));
          const target=route('cart');
          window.location.assign(state(root).promo && root.dataset.code ? route('discount/'+encodeURIComponent(root.dataset.code))+'?redirect='+encodeURIComponent(target):target);
        } catch(e) {
          reset();
          error.textContent=added?words().transition:(e.message || words().error);
          if(added){const a=document.createElement('a');a.href=route('cart');a.textContent=words().cart;error.append(' ',a);}
          error.setAttribute('tabindex','-1');error.focus();
        }
      }));
      if('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches){
        const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('ac-reveal');observer.unobserve(entry.target);}}),{threshold:.08});
        root.querySelectorAll('.ac-week,.ac-small-card,.ac-neu-note,.ac-fit').forEach(n=>observer.observe(n));
        root.acObserver=observer;
      }
    });
  };
  setInterval(()=>roots.forEach(root=>{if(root.isConnected)tick(root);else{root.acObserver?.disconnect();roots.delete(root);}}),1000);
  window.addEventListener('pageshow',reset);
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-ac-root]').forEach(root=>{root.acObserver?.disconnect();roots.delete(root);}));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
})();
  } catch(e) { console.error(e); }
})();

})();
